export default function SummaryRow(_, _ref) {
  var isSummaryRow = _ref.isSummaryRow;

  if (!isSummaryRow) {
    return {};
  }

  return {
    rowClassName: function rowClassName() {
      return isSummaryRow.apply(void 0, arguments) ? 'jmtd-table-plugin-total-row' : null;
    }
  };
}